import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import Selectors from '@/vocabularies/hooks/selectors';

const TermsOption = () => {
  const { href } = Selectors.useTermsLink();
  return (
    <Dropdown.Item
      title=""
      as="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon name="handshake" />
      <FormattedMessage id="header.terms" />
    </Dropdown.Item>
  );
};

export default TermsOption;
